import { render, staticRenderFns } from "./ClientImage.vue?vue&type=template&id=71b5fb60&"
import script from "./ClientImage.vue?vue&type=script&lang=js&"
export * from "./ClientImage.vue?vue&type=script&lang=js&"
import style0 from "./ClientImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('71b5fb60', component.options)
    } else {
      api.reload('71b5fb60', component.options)
    }
    module.hot.accept("./ClientImage.vue?vue&type=template&id=71b5fb60&", function () {
      api.rerender('71b5fb60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClientImage.vue"
export default component.exports